import React from 'react'

type ManualEndSessionProps = {
    endBotSession: (value: boolean) => void;
    timeoutType: number;
}

const ManualEndSession = ({endBotSession, timeoutType}: ManualEndSessionProps) => {

    // 1 user exits from the cross
    // 2 timeout text after 10 mins
    // 3 user ends after query
    // 4 close after live chat
    
    let screenText;

    switch (timeoutType) {
        case 1: screenText = `<div>You’re about to end your chat session. Ending your</div>
                              <div>chat session means you’ll lose your previous</div>
                              <div class="cancel-text">selection.</div>
                              <div>Have you finished your chat session?</div>`;
            break;
        case 2:
            screenText = `<div class="cancel-text">Looks like you don't need any more help.</div>
                          <div>Have you finished your chat session?</div>`;
            break;
        case 3:
            screenText = `<div>No problem. I enjoyed our chat, stop by</div>
                          <div class="cancel-text">again sometime.</div>
                          <div>Have you finished your chat session?</div>`;
            break;
        case 4:
            screenText = `<div class="cancel-text">Thank you for your feedback.</div>
                          <div>Have you finished your chat session?</div>`;
            break;
        default:
            screenText = `<div>No problem. I enjoyed our chat, stop by</div>
                          <div class="cancel-text">again sometime.</div>
                          <div>Have you finished your chat session?</div>`;
        break;
    }

    return (
       <div className="widget__overlay--endsession">  
            {timeoutType === 1 ? <div className="warning-icon">
                <img className="star" src="/images/alert-icon.png"/>
            </div>: null}

            <div className="warning-text" dangerouslySetInnerHTML={{__html: screenText}}></div>

            <div className="action-buttons">
                    <input type="button" value="Yes" className='form-button secondary' onClick={ () => endBotSession(true) }/>
                    <input type="button" value="No" className='form-button secondary' onClick={ () => endBotSession(false) }/>
            </div>
       </div>
    )
}

export default ManualEndSession